import { render, staticRenderFns } from "./FormRequest.vue?vue&type=template&id=d3ddf4d4&"
import script from "./FormRequest.vue?vue&type=script&lang=js&"
export * from "./FormRequest.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/sections/form-request.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports